import SecuredInterestTable from "./SecuredInterestTable";
export default SecuredInterestTable;
